import { useMemo } from 'react'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { Table } from '@components/shared/Table'
import './ViewTractRunsheetsModal.css'

/* type Props = {
    tracts: Tract[]
    show: boolean
    setShow: (show: boolean) => void
    setAssignTractsList: (List: Tract[]) => void
} */

export const List = ({ tracts, show, setShow, setAssignTractsList }) => {
    const handleModal = () => {
        setShow(!show)
    }
    
    const rows = useMemo(
        () =>
            tracts?.map(tract => {
                let assignedTo = ''
                
                if (tract.assignedTo?.length) {
                    assignedTo = `${tract.assignedTo[0].firstName || ''} ${tract.assignedTo[0].lastName || ''}`
                }
                
                return [tract.name || '', `${tract.grossAcreage || ''}`, assignedTo, tract?.county?.name || '']
            }),
        [tracts],
    )
    
    return (
        <CustomModal open={show} modalHandler={() => handleModal()} center modalClass="assign-tract-to-runsheet">
            <div className="modal-header">
                <h2 className="modal-title">Assigned Tracts List</h2>
            </div>
            <div
                className="p-2 modal-body"
                style={{
                    height: '360px',
                    overflow: 'auto',
                }}>
                <Table
                    isButton={false}
                    setShowTable={() => {}}
                    setIsAddTract={() => {}}
                    prefix="tracts-list"
                    headers={['Tract Name', 'Gross Acreage', 'Assigned to', 'County']}
                    sortHeaders={['item-timestamp', 'item-firstName', 'item-lastName', 'item-county']}
                    rows={rows}
                    setAssignTractsList={setAssignTractsList} />
            </div>
            <div className="modal-footer flex justify-between"></div>
        </CustomModal>
    )
}
